import * as React from "react";
function SvgPause(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M14.8 48H9.2V0h5.5v48zm24-48h-5.5v48h5.5V0z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPause);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
